import React from 'react';
import { useTranslation } from 'react-i18next';

export const IndividualOptOut = () => {
  const [t] = useTranslation();
  return <p>{t('taxHelpIndividualNoTaxIdEnteredDescription')}</p>;
};
